import React from "react";
import { Table, Wrapper } from "components";
import { APP_ROLES, useParams, useQueryParams } from "duck";
import { useGetAdminOrganizationQuery } from "requests";

const Users: React.FC = () => {
  const [{ pagination }] = useQueryParams();
  const { id } = useParams();
  const { data, loading } = useGetAdminOrganizationQuery({
    fetchPolicy: "no-cache",
    variables: { _id: +id, page: pagination?.page || 1, itemsPerPage: 20 }
  });
  const users = data?.organization?.users?.collection;

  return (
    <Wrapper withPadding={false}>
      <Table
        loading={loading}
        data={users || []}
        totalCount={data?.organization?.users?.paginationInfo?.totalCount || 0}
      >
        <Table.Column dataKey="email" label="User Email Address" />
        <Table.Column
          dataKey="name"
          label="User First and Last Name"
          render={({ record: user }) => `${user.firstName} ${user.lastName}`}
        />
        <Table.Column
          dataKey="userRole"
          label="Role"
          render={({ value: userRole }) => APP_ROLES[userRole]}
        />
      </Table>
    </Wrapper>
  );
};

export default Users;
